console.log('LOADED: cookies');

// 'regenerator-runtime/runtime' is required to Cookies module
import 'regenerator-runtime/runtime'
import Cookies from 'efile-ui/src/js/modules/cookies/cookies';

(function () {
  const cookies = new Cookies(COOKIE_NAME, COOKIE_PATH);
  cookies.initialize();
})();
